import branchManagementOrdersComponent from './orders.component';
import PrintOrdersModule from './print';

let branchManagementOrdersModule = angular.module('branchManagementOrdersHistory', [PrintOrdersModule])
  .component('branchManagementOrdersHistory', branchManagementOrdersComponent)
  .name;

export default branchManagementOrdersModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/orders/index.js